import Cookies from 'js-cookie';

/**
 * The tracking cookie token value used for HubSpot lead activity tracking.
 * While the hutk value is not required for the submission to be accepted, this token is used to associate analytics data with a contact record,
 * so without this you will not see any page views or analytics source data for the contact record.
 * see for details https://legacydocs.hubspot.com/docs/methods/forms/submit_form
 * */

const HUBSPOT_COOKIE_NAME = 'hubspotutk';

export function getHubspotHutk() {
  return Cookies.get(HUBSPOT_COOKIE_NAME);
}
